import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { keyframes } from 'styled-components';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import Dots from './Dots.js';
import { SpinnerDisplayTextEn } from './i18n/SpinnerDisplayTextEn.js';
import { SpinnerDisplayTextEs } from './i18n/SpinnerDisplayTextEs.js';

var _excluded = ["id", "isShown", "loadingText", "theme", "language", "style", "size", "circleSpinner", "aniDelay"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var StyledSpinnerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 2rem 6rem;\n  z-index: 150;\n\n  border: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
    border = _ref$theme.border,
    palette = _ref$theme.palette;
  return "".concat(border.size.medium, " ").concat(border.style, " ").concat(palette.gray);
}, function (_ref2) {
  var border = _ref2.theme.border;
  return border.radius.medium;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.white;
});
var loadSquare = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n0% {\n  transform: rotateX(180deg);\n}\n50% {\n  transform: rotateY(0);\n}\n100% {\n  transform: rotateY(180deg);\n}\n"])));
var tinyLoadSquare = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n25%, 100% {\n  transform: rotate(90deg);\n"])));
var StyledSquare = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: ", ";\n  position: relative;\n  background-color: ", ";\n  transition: transform 1s;\n  animation-name: ", ";\n  animation-duration: 1.2s;\n  animation-iteration-count: infinite;\n  animation-delay: ", ";\n\n  width: ", ";\n  height: ", ";\n\n  display: ", ";\n  left: ", ";\n"])), function (_ref4) {
  var size = _ref4.size;
  return size === 'tiny' ? '60px .25rem' : '60px auto';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.primary;
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'tiny' ? tinyLoadSquare : loadSquare;
}, function (_ref7) {
  var aniDelay = _ref7.aniDelay;
  return aniDelay !== '' ? aniDelay : '0s';
}, function (_ref8) {
  var size = _ref8.size;
  return size === 'small' ? '3rem' : size === 'tiny' ? '1rem' : '5rem';
}, function (_ref9) {
  var size = _ref9.size;
  return size === 'small' ? '3rem' : size === 'tiny' ? '1rem' : '5rem';
}, function (_ref10) {
  var size = _ref10.size;
  return size === 'tiny' ? 'inline-block' : 'inherit';
}, function (_ref11) {
  var size = _ref11.size;
  return size === 'tiny' ? '46.25%' : '0rem';
});
var StyledLoadingDiv = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: #ad112b;\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-top: -3rem;\n  text-align: center;\n  font-size: 1rem;\n"])));
var StyledDiv = styled('div')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 3.625px;\n  height: 9.625px;\n  background: black;\n  position: absolute;\n  opacity: 0;\n  border-radius: 50px;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);\n  @keyframes fade {\n    from {\n      opacity: 1;\n    }\n    to {\n      opacity: 0.25;\n    }\n  }\n  transform: rotate(", "deg) translate(0, -155%);\n  animation: fade 1s linear infinite;\n  animation-delay: ", "s;\n"])), function (_ref12) {
  var degree = _ref12.degree;
  return degree;
}, function (_ref13) {
  var animationDelay = _ref13.animationDelay;
  return "-".concat(animationDelay);
});
var StyledCircleSpinnerContainer = styled('div')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 3.75rem;\n  height: 3.75rem;\n  margin: 3rem auto;\n  background: white;\n  padding: 10px;\n  border-radius: 50%;\n  border: ", " solid 4px;\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return "".concat(theme.palette.primary);
});
var Spinner = function Spinner(_ref15) {
  var _ref15$id = _ref15.id,
    id = _ref15$id === void 0 ? 'spinner' : _ref15$id,
    _ref15$isShown = _ref15.isShown,
    isShown = _ref15$isShown === void 0 ? false : _ref15$isShown,
    loadingText = _ref15.loadingText,
    _ref15$theme = _ref15.theme,
    theme = _ref15$theme === void 0 ? themes["default"] : _ref15$theme,
    _ref15$language = _ref15.language,
    language = _ref15$language === void 0 ? 'en' : _ref15$language,
    _ref15$style = _ref15.style,
    style = _ref15$style === void 0 ? {} : _ref15$style,
    _ref15$size = _ref15.size,
    size = _ref15$size === void 0 ? 'large' : _ref15$size,
    circleSpinner = _ref15.circleSpinner,
    _ref15$aniDelay = _ref15.aniDelay,
    aniDelay = _ref15$aniDelay === void 0 ? '0s' : _ref15$aniDelay,
    rest = _objectWithoutProperties(_ref15, _excluded);
  var loadingDisplayText = loadingText ? loadingText : language === 'es' ? SpinnerDisplayTextEs['loadingText'] : SpinnerDisplayTextEn['loadingText'];
  var renderCircleSpinner = function renderCircleSpinner() {
    var barArr = [];
    for (var i = 1; i < 13; i++) {
      barArr.push({
        animationDelay: 1 - i * 0.0833,
        degree: i * 30
      });
    }
    return /*#__PURE__*/React.createElement(StyledCircleSpinnerContainer, {
      theme: theme
    }, barArr.map(function (bar, index) {
      return /*#__PURE__*/React.createElement(StyledDiv, {
        animationDelay: bar.animationDelay,
        degree: bar.degree,
        key: index
      });
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, circleSpinner ? /*#__PURE__*/React.createElement(React.Fragment, null, renderCircleSpinner()) : /*#__PURE__*/React.createElement(React.Fragment, null, theme.name === 'secureSite' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledSquare, _extends({
    id: id,
    size: size,
    theme: theme,
    style: style,
    aniDelay: aniDelay
  }, rest)), size !== 'small' && size !== 'tiny' && /*#__PURE__*/React.createElement(StyledLoadingDiv, null, loadingDisplayText.toUpperCase())), theme.name === 'default' && /*#__PURE__*/React.createElement(StyledSpinnerContainer, _extends({
    id: id,
    theme: theme
  }, rest), /*#__PURE__*/React.createElement(Dots, {
    isShown: isShown
  }), /*#__PURE__*/React.createElement("strong", null, loadingDisplayText, "..."))));
};
var _Spinner = withDefaultTheme(/*#__PURE__*/memo(Spinner));

export default _Spinner;
